'use client'
import { useState } from "react";
import { RiShareLine } from 'react-icons/ri'
import tailwindConfig from '@tailwind.config'
import { usePathname } from 'next/navigation'


const ShareButton = ({ title, text, url, cover, dictionary, lang }) => {
    const [isSharing, setIsSharing] = useState(false);

    const pathname = usePathname()
    const segments = pathname.split('/')

    let baseLink = '/'
    const languages = ['en', 'cn', 'th']
    if (segments.length > 1 && languages.includes(segments[1])) {
        baseLink = `/${segments[1]}/`
    }

    const handleClick = async () => {
        setIsSharing(true);

        try {
            const shareData = {
                title: title,
                text: text,
                url: `${baseLink}${url}`,
                image: `${cover}`
            };

            // console.log(shareData)

            const shareDialog = await window.navigator.share(shareData);
            shareDialog.addEventListener("shared", () => {
                setIsSharing(false);
            });
            shareDialog.addEventListener("dismissed", () => {
                setIsSharing(false);
            });
        } catch (error) {
            setIsSharing(false);
        }
    };

    return (
        <button onClick={handleClick} disabled={isSharing}>
            <div className="flex flex-col items-center">
                <RiShareLine
                    color={tailwindConfig.theme.extend.colors.secondary}
                    size={28}
                />
                <span className="text-maincolor">{dictionary.property.share}</span>
            </div>

        </button>
    );
};

export default ShareButton;